module.exports = __webpack_public_path__ + "static/img/o2.a882d03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/o2.jpg
// module id = rgwI
// module chunks = 0